import { instance, config } from './axios.js'
import siteConfig from "../config.js";
const NODE_ENV = process.env.NODE_ENV
const apiConfig = () => {
  return config(siteConfig[NODE_ENV]['apiPrefix'] + '/admin')
}


export default {
  userList({ limit = 0, skip = 0 } = {}) {
    return instance.get(`/userList?limit=${limit}&skip=${skip}`, apiConfig())
  },
  setVip(data) {
    return instance.post('/setVip', data, apiConfig())
  },
  addUser(data) {
    return instance.post('/addUser', data, apiConfig())
  }
}
